var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.4927,
    cy: 43.4216,
    r: 43.0857,
    fill: "#C6CEDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5122 29.2833C45.5122 28.7477 45.2994 28.234 44.9207 27.8552C44.5419 27.4765 44.0282 27.2637 43.4926 27.2637C42.9569 27.2637 42.4432 27.4765 42.0645 27.8552C41.6857 28.234 41.4729 28.7477 41.4729 29.2833V41.4012H29.3551C28.8194 41.4012 28.3057 41.6139 27.927 41.9927C27.5482 42.3715 27.3354 42.8852 27.3354 43.4208C27.3354 43.9565 27.5482 44.4702 27.927 44.8489C28.3057 45.2277 28.8194 45.4405 29.3551 45.4405H41.4729V57.5583C41.4729 58.0939 41.6857 58.6076 42.0645 58.9864C42.4432 59.3652 42.9569 59.5779 43.4926 59.5779C44.0282 59.5779 44.5419 59.3652 44.9207 58.9864C45.2994 58.6076 45.5122 58.0939 45.5122 57.5583V45.4405H57.6301C58.1657 45.4405 58.6794 45.2277 59.0582 44.8489C59.4369 44.4702 59.6497 43.9565 59.6497 43.4208C59.6497 42.8852 59.4369 42.3715 59.0582 41.9927C58.6794 41.6139 58.1657 41.4012 57.6301 41.4012H45.5122V29.2833Z",
    fill: "#032A4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewFile);
export default __webpack_public_path__ + "static/media/overview-file.d0c4ad74acecd597a31c03f5fe02cc2d.svg";
export { ForwardRef as ReactComponent };